// Canonical constants for the campaigns feature.
// Data model reflects the channels + offer model defined in docs/crm-campaings/CAMPAIGN-TYPES-MODEL.md.

export const CAMPAIGN_STATUS = {
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  ACTIVE: 'active',
  PAUSED: 'paused',
  COMPLETED: 'completed',
};

export const CAMPAIGN_STATUSES = Object.values(CAMPAIGN_STATUS);

export const CHANNEL = {
  EMAIL: 'email',
  NETWORK_UPSELL: 'network-upsell',
};

export const CHANNELS = Object.values(CHANNEL);

export const OFFER = {
  NONE: 'none',
  INVITATION: 'invitation',
  DISCOUNT: 'discount',
};

export const OFFERS = Object.values(OFFER);

export const ROLE = {
  OWNER: 'owner',
  ASSISTANT: 'assistant',
  DARK_ADMIN: 'dark-admin',
  TEACHER: 'teacher',
  READER: 'reader',
};

export const EMAIL_TEMPLATE = {
  PROMOTIONAL: 'promotional',
  INVITATION: 'invitation',
  DISCOUNT: 'discount',
  REENGAGEMENT: 'reengagement',
  RECOMMENDATION: 'recommendation',
  ANNOUNCEMENT: 'announcement',
};

export const WIZARD_STEP = {
  BASICS: 1,
  AUDIENCE: 2,
  CONTENT: 3,
  SCHEDULE: 4,
  REVIEW: 5,
};

export const WIZARD_TOTAL_STEPS = 5;

export const LIMITS = {
  CAMPAIGN_NAME_MAX: 100,
  SUBJECT_MAX: 150,
  PREVIEW_TEXT_MAX: 200,
  DISCOUNT_CODE_MAX: 30,
  DISCOUNT_CODE_MIN: 3,
  AUDIENCE_FILTER_VALUES_MAX: 20,
  FEATURED_COURSES_MIN: 1,
  FEATURED_COURSES_MAX: 6,
  TEST_SEND_RECIPIENTS_MAX: 5,
  TEST_SEND_PER_HOUR: 10,
  SEND_AT_MIN_LEAD_MINUTES: 5,
  AUTOSAVE_INTERVAL_MS: 10_000,
  AUDIENCE_PREVIEW_DEBOUNCE_MS: 400,
  SEARCH_DEBOUNCE_MS: 300,
  DEFAULT_RETENTION_DAYS: 30,
  DEFAULT_UPSELL_WINDOW_DAYS: 14,
};

export const FEATURE_FLAG = {
  CAMPAIGNS: 'campaigns',
  NETWORK_UPSELL_LIVE: 'networkUpsells.useLiveCampaigns',
};

// Attribution window for revenue attribution on click (7d post-click).
export const ATTRIBUTION_WINDOW_DAYS = 7;

// Default currency fallback used when the store has no configured currency.
export const DEFAULT_CURRENCY = 'USD';
